<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="连锁管理-库存列表"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-content" ref="itemContent">
                <div class="tab-box">
                    <el-tabs v-model="onTab">
                        <el-tab-pane label="商品列表" name="list">
                            <!--商品列表-->
                            <div class="item-box search-box">
                                <el-input v-model="listSearch.keyword" placeholder="产品名称或产品编码" style="width: 300px" />&nbsp;
                                <ChainStoreSelect v-model="listSearch.store_id" />&nbsp;
                                <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                            </div>
                            <div class="table-box">
                                <el-table :data="listTableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                                          header-cell-class-name="table-ceil"
                                >
                                    <el-table-column
                                            prop="create_datetime"
                                            label="添加时间"
                                            width="160">
                                    </el-table-column>
                                    <el-table-column
                                            prop="title"
                                            label="产品名称"
                                            width="130">
                                    </el-table-column>
                                    <el-table-column
                                            prop="no"
                                            label="产品编码"
                                            width="150">
                                    </el-table-column>
                                    <el-table-column
                                            prop="unit_name"
                                            label="单位"
                                            width="60" />
                                    <el-table-column
                                            prop="category"
                                            label="产品类别"
                                            width="90">
                                    </el-table-column>

                                    <el-table-column
                                            prop="in_num"
                                            label="累计入库"
                                            width="80">
                                    </el-table-column>
                                    <el-table-column
                                            prop="out_num"
                                            label="累计出库"
                                            width="80">
                                    </el-table-column>
                                    <el-table-column
                                            prop="num"
                                            label="当前库存"
                                            width="80">
                                    </el-table-column>
                                    <el-table-column
                                            prop="remind_num"
                                            label="提醒"
                                            width="80">
                                    </el-table-column>
                                    <el-table-column
                                            prop="price"
                                            label="售价"
                                            width="80">
                                    </el-table-column>
                                    <el-table-column
                                            prop="position"
                                            label="存放位置"
                                            width="80">
                                    </el-table-column>
                                    <el-table-column
                                            prop="store_name"
                                            label="所属门店">
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="page-box">
                                <el-pagination
                                        @size-change="pageSizeChange"
                                        @current-change="pageCurrentChange"
                                        :current-page="listPage.nowPage"
                                        :page-sizes="listPage.pageSizes"
                                        :page-size="listPage.pageSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="listPage.count">
                                </el-pagination>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="入库记录" name="in">
                            <!--入库记录-->
                            <div class="item-box search-box">
                                <el-input v-model="inSearch.keyword" placeholder="产品名称或产品编码" style="width: 300px" />&nbsp;
                                <ChainStoreSelect v-model="inSearch.store_id" />&nbsp;
                                <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                            </div>
                            <div class="table-box">
                                <el-table :data="inTableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                                          header-cell-class-name="table-ceil"
                                >
                                    <el-table-column prop="create_datetime" label="入库时间" width="200"></el-table-column>
                                    <el-table-column prop="title" label="产品名称" width="180"></el-table-column>
                                    <el-table-column prop="no" label="产品编码"></el-table-column>
                                    <el-table-column prop="unit_name" label="单位"></el-table-column>
                                    <el-table-column prop="category_name" label="产品类型"></el-table-column>
                                    <el-table-column prop="num" label="入库数量"></el-table-column>
                                    <el-table-column prop="price" label="入库单价"></el-table-column>
                                    <el-table-column prop="total_price" label="入库总价"></el-table-column>
                                    <el-table-column prop="bill_no" label="票据单号" width="120"></el-table-column>
                                    <el-table-column prop="position" label="存放位置" width="100"></el-table-column>
                                    <el-table-column prop="store_name" label="入库门店" width="100"></el-table-column>
                                    <el-table-column prop="staff_name" label="入库人" width="120"></el-table-column>
                                    <el-table-column prop="record" label="备注" width="180"></el-table-column>
                                </el-table>
                            </div>
                            <div class="page-box">
                                <el-pagination
                                        @size-change="pageSizeChange"
                                        @current-change="pageCurrentChange"
                                        :current-page="inPage.nowPage"
                                        :page-sizes="inPage.pageSizes"
                                        :page-size="inPage.pageSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="inPage.count">
                                </el-pagination>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="出库记录" name="out">
                            <!--出库记录-->
                            <div class="item-box search-box">
                                <el-input v-model="outSearch.keyword" placeholder="产品名称或产品编码" style="width: 300px" />&nbsp;
                                <ChainStoreSelect v-model="outSearch.store_id" />&nbsp;
                                <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                            </div>
                            <div class="table-box">
                                <el-table :data="outTableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                                          header-cell-class-name="table-ceil"
                                >
                                    <el-table-column prop="create_datetime" label="出库时间" width="220">
                                        <template slot-scope="data">
                                            <div class="data-box">
                                                {{data.row.create_datetime}}&nbsp;
                                                <el-tag type="danger" effect="light" v-if="data.row.state === '0'">已作废</el-tag>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="title" label="产品名称" width="180"></el-table-column>
                                    <el-table-column prop="no" label="产品编码"></el-table-column>
                                    <el-table-column prop="unit_name" label="单位"></el-table-column>
                                    <el-table-column prop="category_name" label="产品类型"></el-table-column>
                                    <el-table-column prop="num" label="出库数量"></el-table-column>
                                    <el-table-column prop="price" label="出库单价"></el-table-column>
                                    <el-table-column prop="total_price" label="出库总价"></el-table-column>
                                    <el-table-column prop="bill_no" label="票据单号" width="120"></el-table-column>
                                    <el-table-column prop="store_name" label="出库门店" width="100"></el-table-column>
                                    <el-table-column prop="staff_name" label="出库人" width="120"></el-table-column>
                                    <el-table-column prop="record" label="备注" width="180"></el-table-column>
                                </el-table>
                            </div>
                            <div class="page-box">
                                <el-pagination
                                        @size-change="pageSizeChange"
                                        @current-change="pageCurrentChange"
                                        :current-page="outPage.nowPage"
                                        :page-sizes="outPage.pageSizes"
                                        :page-size="outPage.pageSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="outPage.count">
                                </el-pagination>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
        <div class="layout-right-bottom">

        </div>

    </div>

</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import StackBox from "@/model/StackBox";
    import RightTop from "@/model/RightTop";
    import ChainStoreSelect from "@/model/Chain/ChainStoreSelect";
    export default {
        name: "StackList",
        components: {ChainStoreSelect, RightTop, StackBox, SearchBox, Menu},
        data: () => ({
            listSearch: {
                keyword: "",
                store_id: ""
            },
            inSearch: {
                keyword: "",
                store_id: ""
            },
            outSearch: {
                keyword: "",
                store_id: ""
            },
            onTab: "",
            listPage: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            listTableData: [],

            inPage: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            inTableData: [],

            outPage: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            outTableData: [],
        }),
        mounted: function(){
            this.$store.commit("setMenuId", "14-6");
            this.init();
        },
        methods: {
            init(){
                this.switchTab("list");
                this.loadGoodsListData();
                this.loadGoodsStackData(1);
                this.loadGoodsStackData(2);
            }

            //切换tab
            ,switchTab(name){
                this.onTab = name;
            }

            //搜索
            ,searchEvent: function () {
                this.listPage.nowPage = 0;
                this.listPage.count = 0;
                this.inPage.nowPage = 0;
                this.inPage.count = 0;
                this.outPage.nowPage = 0;
                this.outPage.count = 0;
                this.loadGoodsListData();
                this.loadGoodsStackData(1);
                this.loadGoodsStackData(2);
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                switch (this.onTab) {
                    case "in":
                        this.inPage.pageSize = val;
                        this.loadGoodsStackData(1);
                        break;
                    case "out":
                        this.outPage.pageSize = val;
                        this.loadGoodsStackData(2);
                        break;
                    default:
                        this.listPage.pageSize = val;
                        this.loadGoodsListData();
                        break;
                }
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                switch (this.onTab) {
                    case "in":
                        this.inPage.nowPage = val;
                        this.loadGoodsStackData(1);
                        break;
                    case "out":
                        this.outPage.nowPage = val;
                        this.loadGoodsStackData(2);
                        break;
                    default:
                        this.listPage.nowPage = val;
                        this.loadGoodsListData();
                        break;
                }
            }

            //加载商品列表数据
            ,loadGoodsListData () {
                let postData = {
                    page: this.listPage.nowPage,
                    limit: this.listPage.pageSize,
                    search_store_id: this.listSearch.store_id ? this.listSearch.store_id: "",
                    keyword: this.listSearch.keyword
                };

                obj.postData("chain_goods/get_goods_list", postData, function (res) {
                    if(res.errcode === 0){
                        this.listPage.count = res.count;
                        this.listTableData = res.data;
                    }else{
                        this.listTableData = [];
                    }
                }.bind(this));
            }

            //加载出入库记录
            ,loadGoodsStackData (type) {
                let postData = {
                    type: type,
                    page: type === 1 ? this.inPage.nowPage : this.outPage.nowPage,
                    limit: type === 1 ? this.inPage.pageSize : this.outPage.pageSize,
                };

                switch (type) {
                    case 1:
                        postData.search_store_id = this.inSearch.store_id ? this.inSearch.store_id: "";
                        postData.keyword = this.inSearch.keyword;
                        break;
                    case 2:
                        postData.search_store_id = this.outSearch.store_id ? this.outSearch.store_id: "";
                        postData.keyword = this.outSearch.keyword;
                        break;
                }

                obj.postData("chain_goods/get_goods_stack_data", postData, res => {
                    if(res.errcode === 0){
                        if(type === 1){
                            this.inPage.count = res.count;
                            this.inTableData = res.data;
                        }else{
                            this.outPage.count = res.count;
                            this.outTableData = res.data;
                        }
                    }else{
                        if(type === 1){
                            this.inPage.count = 0;
                            this.inTableData = [];
                        }else{
                            this.outPage.count = 0;
                            this.outTableData = [];
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .search-box{
        padding: 6px 0 0;
    }
    .layout-right-body>.item-content>.table-box{
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom: none;
        background-color: #ffffff;
        overflow:hidden;
        padding: 5px 16px 0;
    }
    .page-box{
        padding: 10px 20px;
        background: #ffffff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border-top: 1px solid #ebedf0;
    }
    .layout-right-bottom{
        padding-top: 0px;
    }

    .tab-box{
        background-color: #ffffff;
        position: relative;
        padding: 16px;
    }
</style>
